class so_Wishlist {

    // Get wishlist from cookies
    constructor() {
        this.wl = {'wishlist': []};
        const wishlist_cookie = JSON.parse(getCookie('so_wishlist'));
        if(wishlist_cookie) {
            this.wl = wishlist_cookie;
        }
    }


    addNewItem(item_id, data, url) {
        if(this.itemInList(item_id) == false) {
            var obj = {};
            obj.handle = data.handle;
            obj.title = data.title;
            obj.id = data.id;
            obj.featured_image = data.featured_image;
            obj.url = url;
            this.wl.wishlist.push(obj);

            setCookie('so_wishlist', JSON.stringify(this.wl), 30);
        }
    }

    removeItem(item_id) {
        this.wl.wishlist = this.wl.wishlist.filter(function(item) {
            return item.handle != item_id;
        })
        // eraseCookie('so_wishlist');
        setCookie('so_wishlist', JSON.stringify(this.wl), 30);
    }

    itemInList(item_id) {
        const filteredList = this.wl.wishlist.filter((item) => {
            return item.handle == item_id;
        })
        return filteredList.length > 0;
    }

    toggleItem(item_id, data, url) {
        if(this.itemInList(item_id)) {
            this.removeItem(item_id);
            this.checkWishlistStatus(item_id);
            console.log('removed', this.wl);
        } else {
            this.addNewItem(item_id, data, url);
            this.checkWishlistStatus(item_id);
            console.log('added', this.wl)
        }
    }    
    checkWishlistStatus(item_id) {
        if(jQuery('.add-to-wishlist').length) {
            jQuery('.add-to-wishlist').each(function() {
                const isActive = so_wishlist.itemInList(jQuery(this).data('handle'));
                if(isActive) {
                    jQuery(this).addClass('active');
                } else {
                    jQuery(this).removeClass('active');
                }
            })
        }
    }

}
const so_wishlist = new so_Wishlist();

// jQuery
jQuery(document).ready(function() {
    if(jQuery('.add-to-wishlist').length) {
        jQuery('.add-to-wishlist').each(function() {
            const isActive = so_wishlist.itemInList(jQuery(this).data('handle'));
            if(isActive) {
                jQuery(this).addClass('active');
            }
        })
    }

    function checkWishlistStatus(item_id) {
        if(jQuery('.add-to-wishlist').length) {
            jQuery('.add-to-wishlist').each(function() {
                const isActive = so_wishlist.itemInList(jQuery(this).data('handle'));
                if(isActive) {
                    jQuery(this).addClass('active');
                }
            })
        }
    }

    if(jQuery('#my-wishlist').length) {
        so_wishlist.wl.wishlist.forEach((item) => {
            jQuery('#my-wishlist').append('<div class="product-item product-item-no-sizes">' +
                '<a href="' + item.url + '">' +
                    '<div class="image">' +
                        '<img src="' + item.featured_image + '" width="400" height="400" loading="lazy" />' +
                    '</div>' +
                    '<h4>' + item.title + '</h4>' +
                '</a>' +
            '</div>'
            )
        })
        if(so_wishlist.wl.wishlist.length == 0) {
            jQuery('#my-wishlist').append('<h4 style="color: grey">Jouw verlanglijstje is leeg.</h4>');
        }
    }
})

// Functions
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}